module.exports = __webpack_public_path__ + "img/popup11.99e5a6c5.png";